<template>
    <a class="icon is-small" @click.prevent="toggleValue()">
        <i aria-hidden="true" class="fa" :class="'fa-' + (this.value ? this.icons.checked : this.icons.unchecked)"></i>
    </a>
</template>


<script>
    export default {
        name: 'icon-checkbox',
        props: {
            value: {
                type: Boolean,
            },
            icons: {
                type: Object,
                'default': () => ({
                    checked: 'check-circle',
                    unchecked: 'circle-o',
                }),
            },
        },
        methods: {
            toggleValue() {
                this.$emit('input', !this.value);
            },
        },
    };
</script>



// WEBPACK FOOTER //
// src/views/components/toggle-buttons/icon-checkbox.vue